import { FC, useState } from "react";
import cx from "classnames";
import "styles/table.scss";
import { useDispatch } from "react-redux";
import { setRowData } from "store/slice/search.slice";
import { TableProps } from "types/atoms.types";

const Table: FC<TableProps> = ({ data, columns, uidProperty, onSelect }) => {
  const [selected, setSelected] = useState<number>();
  const dispatch = useDispatch();

  const handleSelection = (selectedRow: any, selectedId: number) => {
    dispatch(setRowData(selectedRow));
    setSelected(selectedId);
    onSelect();
  };

  return (
    <table className="asr-table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.dataProperty}>{col.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((d, i) => (
          <tr
            className={cx({ active: Number(selected) === i })}
            key={i}
            onClick={() => handleSelection(d, i)}
          >
            {columns.map((col, j) => (
              <td key={j}>{d[col.dataProperty] ?? 'N/A'}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
